import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import './Mission.css';

const values = [
  { num: '01', name: 'Transparency', icon: '◈' },
  { num: '02', name: 'Objectivity',  icon: '◎' },
  { num: '03', name: 'Accountability', icon: '◆' },
  { num: '04', name: 'Innovation',   icon: '◇' },
];

export default function Mission() {
  const leftRef  = useFadeIn();
  const rightRef = useFadeIn();

  return (
    <section id="mission" className="mission-section">
      <div className="mission-bg-text">SECURE</div>
      <div className="section-label">Mission &amp; Values</div>

      <div className="mission-layout">
        {/* LEFT — mission text */}
        <div className="mission-text fade-in" ref={leftRef}>
          <h2 className="section-title">
            To <em>secure</em> and advance corporate and local interests.
          </h2>
          <p className="mission-body" style={{ marginTop: '2rem' }}>
            Security is not incidental to what we do — it is the foundation upon which every
            function we perform is built. Our mission drives us to anticipate threats before they
            materialize, to illuminate risks others overlook, and to equip organizations with the
            intelligence they need to operate with confidence.
          </p>
          <p className="mission-body">
            We lead intelligence efforts not through brute force, but with precision — combining
            deep analytical expertise, technological capability, and an unwavering commitment to
            lawful, ethical conduct. Every assessment, every audit, every solution we deliver
            answers to a single standard: is our client more secure?
          </p>
          <div className="mission-statement">
            <p>
              "Performing such other functions and duties related to intelligence — always in
              service of a more secure, more transparent world."
            </p>
          </div>
        </div>

        {/* RIGHT — values */}
        <div className="values-right fade-in delay-2" ref={rightRef}>
          <p className="mission-body">
            Our values are not aspirational — they are operational. Every analyst, every report,
            every engagement is held to these four standards without exception.
          </p>
          <div className="values-grid">
            {values.map((v) => (
              <div className="value-row" key={v.num}>
                <div className="value-num">{v.num}</div>
                <div className="value-name">{v.name}</div>
                <div className="value-icon">{v.icon}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
